import { Icon, IconProps } from "@chakra-ui/icons";

const TriagleDownIcon = (props: IconProps) => {
  return (
    <Icon width="1em" height="1em" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M8.64061 4C8.74841 4 8.83526 4.0442 8.90115 4.1326C8.96705 4.22084 9 4.32384 9 4.44159C9 4.47111 8.96281 4.57331 8.88843 4.74817L6.38166 7.79796C6.32412 7.86813 6.26459 7.91934 6.20306 7.95161C6.14154 7.98387 6.07385 8 6 8C5.92615 8 5.85846 7.98387 5.79694 7.95161C5.73542 7.91934 5.67588 7.86813 5.61834 7.79796L3.11138 4.74817C3.0769 4.70607 3.04972 4.65904 3.02983 4.6071C3.00994 4.55532 3 4.49975 3 4.44038C3 4.32182 3.03295 4.21874 3.09885 4.13115C3.16474 4.04372 3.25159 4 3.35939 4L8.64061 4Z"
        fill="currentcolor"
      />
    </Icon>
  );
};

export default TriagleDownIcon;
